import { getSessionCountry } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getSessionCountry";
import { COUNTRY } from "@faire/web/common/consts/COUNTRY";
import { PRIMARY_COUNTRY } from "@faire/web/common/consts/PRIMARY_COUNTRY";
import { useStrictLocalization } from "@faire/web/common/localization";
import isEqual from "lodash/isEqual";
import uniqWith from "lodash/uniqWith";
import { useMemo } from "react";

export const useCountryOptions = () => {
  const sessionCountry = getSessionCountry();
  const { strictLocalize } = useStrictLocalization();

  return useMemo(() => {
    return uniqWith(
      PRIMARY_COUNTRY(strictLocalize).concat(COUNTRY(strictLocalize)),
      isEqual
    ).sort((a, b) => {
      if (a.value === sessionCountry) {
        return -1;
      } else if (b.value === sessionCountry) {
        return 1;
      }
      return 0;
    });
  }, [sessionCountry, strictLocalize]);
};
